export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask Kriptowang",
            h1B: "MetaMask Bank Kriptowang",
            h1C: "Dompet DeFi Kriptowang",
            h1D: "Coinbase Bank Kriptowang",
            h1E: "MetaMask Bank Simpanan",
            h1F: "Betterment",
            h2: "Jemput Rakan",
            h3: "Pautkan Akaun Pengeluaran",
            h4: "Sertai Simpanan",
            h4B: "Deposit Kriptowang",
            h4C: "Tambah Nilai Mata Wang Digital",
            h5: "Pelaburan Terpilih",
            h5B: "Perdagangan Kontrak Pantas",
            h5c: "Deposit",
            h6: "Kolam Pengguna",
            h7: "Akaun USDT",
            h8: "Jumlah Hasil",
            h9: "Node Sah",
            h10: "Peserta",
            h11: "Pendapatan",
            h12: "Rekod Pendapatan",
            h13: "Alamat",
            h14: "Nombor",
            h15: "Soalan Lazim",
            h16: "Bagaimana untuk menyertai?",
            h17: "Pengguna yang dihormati, jika anda ingin menyertai simpanan dompet USDT, anda perlu mematuhi peraturan pengguna platform, mengikuti keputusan platform dengan ketat, dan menerima pengawasan jabatan risiko. Anda secara automatik akan memperoleh kebenaran deposit. Selamat menyertai, terima kasih.",
            h17B: "Pengguna yang dihormati, jika anda ingin menyertai simpanan dompet USDT, anda perlu mematuhi peraturan pengguna platform, mengikuti keputusan platform dengan ketat, dan menerima pengawasan jabatan risiko. Anda secara automatik akan memperoleh kebenaran deposit. Selamat menyertai, terima kasih.",
            h18: "Bagaimana untuk mengeluarkan wang?",
            h19: "Pendapatan harian akan dimasukkan secara automatik ke baki akaun. Setelah pengeluaran USDT berjaya, ia akan ditambah secara automatik ke akaun dompet USDT. Jika ingin mengeluarkan dalam Yen, sila hubungi pusat khidmat pelanggan. Terima kasih atas penyertaan dan sokongan anda.",
            h19B: "Pendapatan harian akan dimasukkan secara automatik ke baki akaun. Setelah pengeluaran USDT berjaya, ia akan ditambah secara automatik ke akaun dompet USDT. Jika ingin menggunakan kaedah pengeluaran lain, sila hubungi khidmat pelanggan dalam talian!",
            h20: "Bagaimana pendapatan dikira?",
            h21B: "Beli dalam bentuk kitaran, keuntungan berbeza mengikut tahap VIP\nVIP1  100u~5000u, Kadar Faedah: 1.8%\nVIP2  5000u~20000u, Kadar Faedah: 2.6%\nVIP3  20000u~50000u, Kadar Faedah: 3.5%\nVIP4  50000u~80000u, Kadar Faedah: 4.7%\nVIP5  80000u~120000u, Kadar Faedah: 5.3%\nVIP6  120000u~160000u, Kadar Faedah: 6.2%\nVIP7  160000u~200000u, Kadar Faedah: 7.3%\nVIP8  200000u ke atas, Kadar Faedah: 8%\n\n",
            h21: "Setelah berjaya menyertai, kontrak simpanan akan mula mengira pendapatan.",
            h22: "Dari mana datangnya pendapatan simpanan?",
            h23: "Setelah pengguna menyertai simpanan, kontrak simpanan menjadi sah. Faedah dikira dua kali sehari, pada 00:00 dan 12:00. Selepas kontrak simpanan sah, dana masuk ke mod pengurusan, dan platform bertanggungjawab terhadap keselamatan dana. Untuk memastikan keselamatan akaun, sila patuhi peraturan platform dan hubungi khidmat pelanggan dalam talian jika terdapat sebarang isu.",
            h23B: "Setelah pengguna menyertai simpanan, kontrak simpanan menjadi sah. Faedah dikira dua kali sehari, pada 00:00 dan 12:00. Selepas kontrak simpanan sah, dana masuk ke mod pengurusan, dan platform bertanggungjawab terhadap keselamatan dana. Untuk memastikan keselamatan akaun, sila patuhi peraturan platform dan hubungi khidmat pelanggan dalam talian jika terdapat sebarang isu.",
            h24: "Berapa banyak bonus?",
            h25: "Anda boleh berkongsi platform saya dengan rakan. Apabila rakan menyertai, anda akan mendapat bonus 20% daripada jumlah deposit pertama mereka dan secara kekal menerima 10% komisen daripada pendapatan mereka. Pautan awam untuk berkongsi berada di penjuru kanan atas halaman utama.",
            h25B: "Anda boleh berkongsi platform ini dengan rakan. Apabila rakan menyertai, anda akan mendapat bonus 20% daripada jumlah deposit pertama mereka dan secara kekal menerima 10% komisen daripada pendapatan mereka. Pautan berkongsi berada di penjuru kanan atas halaman utama.",
            h26: "Baki tersedia",
            h27: "Jumlah deposit",
        
            h88: "Latar Belakang Platform",
            h89: "Betterment\nTahun Penubuhan: 2008\nIbu Pejabat: New York, AS\nKedudukan: Robo-Advisor dan FinTech, menyediakan portfolio pelaburan automatik dan pengurusan tunai\nAgensi Pengawalseliaan: Di bawah pengawasan Suruhanjaya Sekuriti (SEC) dan ahli FINRA\nSkala Pelanggan: Mengurus aset lebih daripada 40 bilion USD\nPelanggan: Lebih 800,000 individu dan perusahaan",
            h90: "Kelebihan Platform",
            h91: "✔️ Robo-Advisor pertama di AS, berpengalaman\n✔️ Portfolio berasaskan Teori Pengagihan Aset Moden (MPT), risiko diagihkan\n✔️ Fungsi pengoptimuman cukai\n✔️ Akaun tunai berfaedah tinggi, sangat cair\n✔️ Operasi sepenuhnya digital, antara muka mudah",
            h92: "Sesuai untuk",
            h93: "★ Pengguna yang ingin pelaburan stabil jangka panjang dan tidak ingin kerap mengurus\n★ Pelabur muda yang mahukan pengurusan automatik, menjimatkan masa\n★ Pelabur dengan gabungan pelaburan + simpanan berfaedah tinggi + akaun persaraan\n★ Pelabur biasa yang ingin memasuki pasaran kewangan dengan kos rendah",
        
            h28: "Pendapatan Hari Ini",
            h29: "Jumlah Pendapatan",
            h30: "Pengeluaran",
            h31: "Rekod",
            h32: "Baki Tersedia",
            h33: "Jumlah Pengeluaran",
            h34: "Sila masukkan jumlah pengeluaran",
            h35: "Semua",
            h36: "Pengeluaran",
            h37: "Soalan Lazim",
            h38: "Laporan Audit Keselamatan",
            h39: "Rakan Kongsi",
            h40: "Rakan Perniagaan Kami",
            h41: "Paparkan Nombor Kad Bank",
            h42: "Halaman Sebelumnya",
            h43: "Halaman Seterusnya",
            h44: "Ini adalah halaman pertama",
            h45: "Sila masukkan jumlah pengeluaran",
            h46: "Baki tidak mencukupi",
            h47: "Ini adalah halaman terakhir",
            h48: "Pendapatan",
            h49: "Perbelanjaan",
            h50: "Operasi terlalu kerap, sila cuba lagi kemudian.",
            h51: "Laporan Audit",
            h52: "Faedah Deposit Coin",
            h521: "Faedah Deposit",
            h53: "Transaksi Pesanan",
            h54: "Bonus Pendaftaran",
            h55: "Bonus Jemputan",
            h56: "Pengeluaran",
            h57: "Tambah Nilai",
            h58: "Deposit",
            h59: "Pengeluaran",
            h591: "Deposit Berjaya",
            h592: "Deposit Gagal",
            h593: "Baki Tidak Cukup",
            h60: "Hadiah USDT melalui Pemindahan Kriptowang",
            h61: "Terima kasih kerana sentiasa menyokong MetaMask Bank. Untuk memudahkan simpanan, gunakan kriptowang (USDT ETH BTC) untuk deposit dan dapatkan bonus simpanan. Deposit lebih 1000 USDT dapat 30 USDT, lebih 5000 USDT dapat 200 USDT, lebih 10000 USDT dapat 5% daripada setiap jumlah deposit. (Pengeluaran melalui dompet kriptowang juga mendapat faedah yang sama)",
            h61B: "Terima kasih kerana sentiasa menyokong Coinbase Bank. Gunakan kriptowang (USDT ETH BTC) untuk deposit dan dapatkan bonus simpanan. Deposit lebih 1000 USDT dapat 30 USDT, lebih 5000 USDT dapat 200 USDT, lebih 10000 USDT dapat 5% daripada setiap jumlah deposit.",
            h61C: "Terima kasih kerana sentiasa menyokong MetaMask Bank. Gunakan kriptowang (USDT ETH BTC) untuk deposit dan dapatkan bonus simpanan. Deposit lebih 1000 USDT dapat 30 USDT, lebih 5000 USDT dapat 200 USDT, lebih 10000 USDT dapat 5% daripada setiap jumlah deposit.",
            h61D: "Terima kasih kerana sentiasa menyokong Betterment. Gunakan kriptowang (USDT ETH BTC) untuk deposit dan dapatkan bonus simpanan. Deposit lebih 1000 USDT dapat 30 USDT, lebih 5000 USDT dapat 200 USDT, lebih 10000 USDT dapat 5% daripada setiap jumlah deposit.",
            h62: "Jumlah pengeluaran anda ialah {amount}, yuran ialah {fee}%!",
            h63: "Sahkan",
            h99: "Akan Dibuka",
        },
        bankcard: {
            b1: "Akaun Bank",
            b2: "Nama Institusi Kewangan",
            b3: "Sila masukkan nama institusi kewangan",
            b4: "Nama Cawangan",
            b5: "Sila masukkan nama cawangan",
            b6: "Nombor Cawangan",
            b7: "Sila masukkan nombor cawangan",
            b8: "Nombor Akaun (Biasa)",
            b9: "Sila masukkan nombor akaun",
            b10: "Nama Samaran",
            b11: "Sila masukkan nama pengguna",
            b12: "Nama Akaun",
            b13: "Sila masukkan nama pemilik akaun",
            b14: "Pautkan",
            b15: "Alamat Mata Wang Digital",
            b16: "Sila masukkan alamat mata wang digital",
        },
        usdt: {
            u1: "Pesanan Saya",
            u2: "Deposit",
            u3: "Sila pilih tempoh kontrak:",
            u4: "Harga Beli:",
            u5: "Sila masukkan jumlah deposit",
            u6: "Tambah Beli",
            u7: "Kurangkan Beli",
            u8: "Operasi Berjaya",
            u9: "Sekurang-kurangnya sedikit"
        },
        order: {
            o0: "Pesanan Saya",
            o1: "Nombor Pesanan",
            o2: "Jenis Pesanan",
            o3: "Jumlah Beli",
            o4: "Jumlah Jual",
            o5: "Jumlah Bayaran",
            o6: "Tempoh Kontrak",
            o7: "Status Pesanan",
            o8: "Status Penyelesaian",
            o9: "Masa Penyelesaian",
            o10: "Masa Pesanan",
            o11: "Tambah Beli",
            o12: "Kurangkan Beli",
            o13: "Telah Dijual",
            o14: "Untung",
            o15: "Rugi",
            o16: "Telah Dibayar",
            o17: "Titik Pulang Modal"
        },
        recharge: {
            r1: "Jumlah Tambah Nilai",
            r2: "Jumlah Tambah Nilai",
            r3: "Jenis Tambah Nilai",
            r4: "Sila Pilih",
            r5: "Alamat Tambah Nilai",
            r6: "Nombor Pesanan Pemindahan",
            r7: "Telah Dipindahkan",
            r8: "Dalam Semakan",
            r9: "Input Tidak Betul",
            r10: "Sila Pilih Kaedah Pembayaran",
            r11: "Jumlah minimum tambah nilai ialah",
            r12: "Jumlah maksimum tambah nilai ialah",
            r13: "Sila masukkan jumlah",
            r14: "Muat naik tangkapan skrin pembayaran",
            r15: "Sila muat naik tangkapan skrin pembayaran",
            r16: "Hantar Berjaya",
            r17: "Batal",
            r18: "Sahkan",
        },
        rechargeDetails: {
            r1: "Rekod Tambah Nilai",
            r2: "Jumlah Tambah Nilai",
            r3: "Dalam Semakan",
            r4: "Tambah Nilai Berjaya",
            r5: "Tambah Nilai Gagal"
        },
		cert: {
		    c1: "Pengesahan identiti sebenar",
		    c2: "Nama sebenar",
		    c21: "Sila masukkan nama sebenar anda",
		    c3: "Jenis pengesahan",
		    c31: "Kad pengenalan",
		    c32: "Pasport",
		    c33: "Lesen memandu",
		    c10: "Masukkan jenis pengesahan",
		    c4: "Bahagian hadapan dokumen",
		    c41: "Sila muat naik bahagian hadapan dokumen",
		    c5: "Bahagian belakang dokumen",
		    c51: "Sila muat naik bahagian belakang dokumen",
		    c6: "Hantar",
		    c7: "Berjaya dihantar, menunggu semakan...",
		    c8: "Pengesahan diluluskan",
		    c9: "Pengesahan identiti gagal, sila muat naik semula",
		    c11: "Sedang disemak",
		    "传入字段不完整": "Medan input tidak lengkap",
		    "已认证过": "Sudah disahkan",
		    "审核中": "Sedang disemak"
		}
		 }